import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReportRunnerComponent } from '../../components/report-runner/report-runner.component';

@Component({
  selector: 'app-mediation-report',
  imports: [ReportRunnerComponent],
  templateUrl: './mediation-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediationReportComponent {}
